// extracted by mini-css-extract-plugin
export default {"heading":"nj-z","list":"oj-z"};